import React, {useEffect, useState} from 'react';
import {Container, Col, Row} from 'reactstrap';
import ShowIf from 'funnel-schedule/ShowIf';
import HideIf from 'funnel-schedule/HideIf';
import PageMeta from 'components/PageMeta';
import Header from 'components/Header';
import Video from 'components/Video';
import SalesNav from 'components/SalesNav';
import CheckoutButton from 'components/CheckoutButton';
import NumberItem from 'components/NumberItem';
import BackgroundImageTextSection from 'components/BackgroundImageTextSection';
import CountdownTimer from 'components/CountdownTimer';
import ImgBullet from 'components/ImgBullet';
import SpeakerInfoSection from 'components/SpeakerInfoSection';
import {DynamicSalesCta, SalesCta297, SalesCta297NoTimer, SalesCta497, SalesDisclaimer} from 'components/SalesCta';
import ModuleAccordion, {ModuleAccordionExpanded} from 'components/ModuleAccordion';
import BonusList from 'components/BonusList';
import Guarantee from 'components/Guarantee';
import FaqList from 'components/FaqList';
import {TestimonialBubble} from 'components/Testimonial';
import ModalExitSales from 'components/ModalExitSales';
import Footer from 'components/Footer';
import ShareButtons from 'components/ShareButtons';
import {Sticky, StickyContainer} from 'react-sticky';
import pptLogo from 'static/logo/frn-logo-ppt.svg';
import pptLogoWhite from 'static/logo/frn-logo-ppt-white.svg';
import {useUserState} from 'contexts/user';
import {usePhaseState} from 'funnel-schedule/phase-context';
import HeaderVideo from 'components/Elements/HeaderVideo';
import {subscribeToCampaign} from 'react-controlled-ab/datalayers/vwo';
import ABTest from 'react-controlled-ab/components/ABTest';
import Section, {SectionImage} from 'components/Elements/Section';
import track from 'utils/track';
import IconList, {IconListItem} from 'components/Elements/IconList';
import {faQuestionCircle} from '@fortawesome/pro-light-svg-icons';
import useBalanceText from 'utils/useBalanceText';

export default function SalesIndex({
  noShare = false,
  linkLogo = false,
  noExitIntent = false,
  noFixedVideo = false,
  ctaOverride = null,
  ctaNoTimer = false,
  variant = null,
  ...props
}) {
  const {bucket, email, registrationId} = useUserState();
  const {
    phases: {
      default: defaultSchedule = {
        phase: 'before'
      },
      sales: salesSchedule = {
        phase: 'during',
        salesEnd: '',
        isSalesDay: false
      },
      webinar: webinarSchedule = {
        phase: 'before'
      }
    }
  } = usePhaseState();

  useEffect(() => {
    const {HS_BEACON_ID} = process.env;
    if (!HS_BEACON_ID || !window.Beacon) return;
    window.Beacon('init', HS_BEACON_ID);
    return () => {
      window.Beacon('destroy');
    };
  }, []);

  const salesEnd = new Date(salesSchedule.salesEnd).getTime();
  const salesFullPrice =
    (!email && !registrationId && !ctaOverride) ||
    (!ctaOverride && webinarSchedule.phase === 'downsell') ||
    (!ctaOverride && webinarSchedule.phase === 'after') ||
    ctaOverride === 'sales497';

  useEffect(() => {
    track('Product Viewed', {
      product_id: 'ppt',
      sku: 'ppt',
      name: 'Plant-Powered & Thriving',
      variant: !salesFullPrice ? 'ppt-special-wlc-30daytrial' : 'ppt-wlc-30daytrial',
      value: !salesFullPrice ? 297 : 497,
      currency: 'usd'
    });
  }, [salesFullPrice]);

  function CtaBox(props) {
    return (
      <>
        {ctaOverride ? (
          <>
            {ctaOverride === 'sales297' ? (
              <>
                {ctaNoTimer ? (
                  <SalesCta297NoTimer {...props} />
                ) : (
                  <SalesCta297 date={salesEnd} timerText="Your discount expires in:" {...props} />
                )}
              </>
            ) : (
              <SalesCta497 {...props} />
            )}
          </>
        ) : (
          <DynamicSalesCta {...props} />
        )}
      </>
    );
  }

  useBalanceText();
  return (
    <div className="page d-flex flex-column">
      <PageMeta
        title="Join Plant-Powered & Thriving!"
        description="Make FOOD the foundation of YOUR health by joining Plant-Powered & Thriving"
      />

      {variant === 'ad' ? (
        <Header className="background-purple header-wrap" logoWhite style="dark" linkLogo={linkLogo} />
      ) : (
        ''
      )}

      <div className="page-content">
        <Section id="ppt-header" color="black" className="section-angle-first" innerClass="text-white text-shadow">
          <header className="ppt-header-join header-wrap text-center mb-4">
            <Container className="py-3">
              <Row>
                <Col className="d-flex align-items-center flex-column flex-lg-row justify-content-lg-center">
                  <div className="mb-2 mb-lg-0 mr-lg-2">Food Revolution Network Presents...</div>
                  <img className="img-fluid logo-ppt" src={pptLogoWhite} />
                </Col>
              </Row>
            </Container>
          </header>

          <div className="ppt-header-cta text-center">
            <Container>
              <Row className="d-flex justify-content-center">
                <Col>
                  <h3 className={!salesFullPrice ? 'section-heading' : 'section-heading mb-3'}>
                    {
                      {
                        1: <>Make healthy eating an irresistible habit you love.</>,
                        2: <>Take your healthy eating lifestyle to the next level.</>,
                        3: <>Take your healthy eating lifestyle to the next level.</>
                      }[bucket]
                    }
                  </h3>
                </Col>
              </Row>
              {!salesFullPrice ? (
                <Row className="d-flex justify-content-center">
                  <Col lg="10" className="video-col px-0 px-sm-3">
                    <HeaderVideo
                      bgColor="black"
                      className="text-white"
                      sku="ppt"
                      price={!salesFullPrice ? '297' : '497'}
                      slug={!salesFullPrice ? 'ppt-special-wlc-30daytrial' : 'ppt-wlc-30daytrial'}
                      url="https://vimeo.com/369915260/8e846a566e"
                      playing={variant === 'ad' ? 'false' : 'true'}
                      sales
                      headline={<h4 className="section-heading text-white">Make FOOD the foundation of YOUR health</h4>}
                      salesBtnText="Join Now!"
                      noFixed={noFixedVideo}
                      label="PPT - Sales Video - Join"
                    />
                  </Col>
                </Row>
              ) : null}
              <Row className="d-flex justify-content-center">
                <Col sm="10" md="12" lg="10">
                  <h4 className={!salesFullPrice ? 'mb-0' : 'section-heading mb-0'}>
                    With John & Ocean Robbins & Chef Cynthia Louise
                  </h4>
                </Col>
              </Row>
              <Row className="d-flex justify-content-center my-4">
                <Col xs="10" md="8" lg="6" xl="5">
                  <img className="img-fluid" src={require('static/speaker/john-ocean-cynthia-wide.png')} />
                </Col>
              </Row>
              <Row className="d-flex justify-content-center">
                <Col md="11" lg="9" xl="7">
                  <h5 className="section-heading">
                    Make FOOD the foundation of YOUR health by joining Plant-Powered & Thriving
                  </h5>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="header-cta-wrap mt-5">
                    {!salesFullPrice ? (
                      <>
                        <h2 className="section-heading mb-3">
                          Right Now Just <del>$497</del> $297
                        </h2>
                        {ctaOverride === 'sales297' ? (
                          <>
                            {ctaNoTimer ? null : (
                              <>
                                <div className="cta-timer mb-3">
                                  <div className="offer-box-timer-text">Your discount expires in:</div>
                                  <CountdownTimer time={salesEnd} />
                                </div>
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <div className="cta-timer mb-3">
                              <div className="offer-box-timer-text">Your discount expires in:</div>
                              <CountdownTimer time={webinarSchedule.time * 1000 + 345600000} />
                            </div>
                          </>
                        )}
                        <CheckoutButton sku="ppt" price="297" slug="ppt-special-wlc-30daytrial" />
                      </>
                    ) : (
                      <>
                        <h2 className="section-heading">Right Now $497</h2>
                        <CheckoutButton sku="ppt" price="497" slug="ppt-wlc-30daytrial" />
                      </>
                    )}
                    <SalesDisclaimer iconColor="white" />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </Section>

        <div className="scroll-content ppt-join-scroll-content">
          <SalesNav />

          <section id="intro">
            <SectionImage
              id="ppt-if-you-want"
              color="white"
              imgPosition="right"
              imgUrl={require('static/backgrounds/kitchen-silly-square.jpg')}
              imgUrlMobile={require('static/backgrounds/kitchen-silly.jpg')}
            >
              <h3 className="section-heading">If you want to:</h3>
              <ul className="list-check-green">
                <li>Save time and money while eating well</li>
                <li>End brain fog and perform at your best all day long</li>
                <li>Feel great about what you’re putting in your body</li>
                <li>Know you’re eating proven anticancer, anti-heart disease, and anti-Alzheimer’s foods</li>
                <li>
                  Enjoy living in a way that’s humane and contributes to a healthier planet for future generations
                </li>
              </ul>
              <h5 className="text-700 mb-0">
                <em>You're in the right place!</em>
              </h5>
            </SectionImage>

            <SectionImage
              id="ppt-right-place"
              color="light-gray"
              imgPosition="left"
              imgUrl={require('static/backgrounds/kitchen-prep-square.jpg')}
              imgUrlMobile={require('static/backgrounds/kitchen-prep.jpg')}
            >
              <h2 className="section-heading">
                In Plant-Powered & Thriving, we’ll teach you how to do all of that, and to:
              </h2>
              <ul className="list-check-green">
                <li>
                  Prepare <strong>healthy</strong> meals & snacks
                </li>
                <li>
                  Take <strong>pleasure</strong> in wholesome food
                </li>
                <li>
                  Enjoy the most delicious healthy <strong>recipes</strong> of your life
                </li>
                <li>
                  Discover a <strong>community</strong> to support your success
                </li>
                <li>
                  Get the <strong>nutrients</strong> you need
                </li>
                <li>
                  Make good food choices with <strong>confidence</strong>
                </li>
              </ul>
            </SectionImage>

            <Section id="ppt-introducing" color="white">
              <Container>
                <Row className="d-flex justify-content-center">
                  <Col lg="10">
                    <h2 className="section-heading text-center">Introducing...</h2>
                    <Row className="d-flex justify-content-center">
                      <Col xs="11" sm="9" md="7" lg="5" xl="4">
                        <h2 className="section-heading">
                          <img className="img-fluid" src={pptLogo} />
                        </h2>
                      </Col>
                    </Row>
                    <Row className="d-flex justify-content-center mb-3">
                      <Col xs="12" lg="8">
                        <img className="img-fluid" src="https://cdn.foodrevolution.org/ppt/ppt-product-image.png" />
                      </Col>
                    </Row>
                    <p>Do you long to:</p>
                    <IconList iconColor="purple">
                      <IconListItem icon={faQuestionCircle}>Lose those excess pounds?</IconListItem>
                      <IconListItem icon={faQuestionCircle}>Prevent or reverse a chronic disease?</IconListItem>
                      <IconListItem icon={faQuestionCircle}>Experience positive moods more often?</IconListItem>
                      <IconListItem icon={faQuestionCircle}>Enjoy more vitality and mojo?</IconListItem>
                      <IconListItem icon={faQuestionCircle}>
                        Eat and live in a way that protects and heals the earth?
                      </IconListItem>
                    </IconList>
                    <p>
                      It doesn’t matter if you’re in the “prime of life” or entering your “golden years” — If healthy
                      eating is already an important part of your life, this is a great opportunity to take it to the
                      next level, so you can make sure all your “bases are covered,” connect with kindred spirits on
                      your journey, and enjoy more confidence, energy, and peace.
                    </p>
                  </Col>
                </Row>
              </Container>
            </Section>
            <Section id="ppp-testimonials-1" color="light-gray">
              <Container>
                <Row>
                  <Col>
                    <h2 className="section-heading text-center">What do participants have to say?</h2>
                    <p className="text-center text-small mb-5 balance-text">
                      <i>
                        These stories are from people who’ve found success with our programs. Each of them is unique.
                        And so are you! Your experiences will vary, of course. And no, we never offer compensation for
                        these statements!
                      </i>
                    </p>
                    <TestimonialBubble id="patsy" bgColor="white" />
                    <hr className="my-5" />
                    <TestimonialBubble id="sheila-m" bgColor="white" />
                    {variant === 'ad' ? null : (
                      <>
                        <hr className="my-5" />
                        <TestimonialBubble id="claudette" bgColor="white" />
                      </>
                    )}
                    <hr className="my-5" />
                    <TestimonialBubble id="betsy-g" bgColor="white" />
                    <hr className="my-5" />
                    <TestimonialBubble id="france-t" bgColor="white" />
                  </Col>
                </Row>
              </Container>
            </Section>
            <Section id="ppt-introducing-2" color="white">
              <Container>
                <Row className="d-flex justify-content-center">
                  <Col lg="10">
                    <h3 className="section-heading">
                      This six-module course will give you science-backed strategies and a clear path to your healthiest
                      and best life.
                    </h3>
                    <h3>Plus...</h3>
                    <NumberItem number="1" title="Quick & easy prep!">
                      Use PROVEN SHORTCUTS to prepare simple meals when you’re in a hurry.
                    </NumberItem>
                    <NumberItem number="2" title="Plan effectively">
                      Find out how to save time, boost energy, and reduce stress. We’ll show you how!
                    </NumberItem>
                    <NumberItem number="3" title="Reduce your grocery bill AND eat well">
                      Learn the 5 keys to saving money, while eating delicious and healthy food. Some families can save
                      $2,000/year or more with these simple tips!
                    </NumberItem>
                    <NumberItem number="4" title="Guilt-free comfort foods">
                      Find out how to create healthier versions of some of your favorite comfort foods.
                    </NumberItem>
                    <NumberItem number="5" title="Dine out smartly">
                      Be able to CONFIDENTLY select healthier fare when eating out.
                    </NumberItem>
                    <NumberItem number="6" title="Bring more joy, thanksgiving..." className="mb-0">
                      ...and delight to your meals! And to your family, too! No matter what they eat!
                    </NumberItem>
                  </Col>
                </Row>
              </Container>
            </Section>

            <Section
              id="ppt-personal-note"
              className="background-image-wood-panel background-image-left-bottom background-cover background-fixed"
              color="white"
              angle="none"
              innerClass="section-inner-noangle-offset"
            >
              <Container>
                <Row>
                  <Col>
                    <div className="background-white px-3 py-4 px-lg-5 py-lg-5 my-3">
                      <Row className="d-flex align-items-center justify-content-center mb-lg-4">
                        <Col xs="12" sm="8" lg="4" xl="3" className="order-lg-2 text-center mb-4 mb-lg-0">
                          <img
                            className="img-ocean-note rounded-circle"
                            src={require('static/speaker/ocean-robbins.jpg')}
                          />
                        </Col>
                        <Col xs="12" lg="8" xl="9" className="order-lg-1">
                          <h2 className="section-heading mb-4">A personal note from Ocean Robbins</h2>
                          <h4 className="my-4">
                            In his 70s, my Grandpa Irv (who founded Baskin-Robbins ice cream company) became seriously
                            ill...
                          </h4>
                        </Col>
                      </Row>
                      <Row className="d-flex align-items-center justify-content-center">
                        <Col xs="12" sm="8" lg="4" xl="3" className="img-ocean-note-icecream-row text-center">
                          <img
                            className="img-ocean-note img-ocean-note-icecream img-fluid img-rotate-left"
                            src={require('static/irvine-with-ice-cream.jpg')}
                          />
                        </Col>
                        <Col xs="12" lg="8" xl="9">
                          <p>
                            <strong>
                              He’d always eaten the standard American diet, plus a double scoop of ice cream on top, and
                              now he was suffering from the standard American diseases.
                            </strong>
                          </p>
                          <h5 className="my-4">That was his wake-up call.</h5>
                          <p>
                            His doctor told him that he'd have to take seven medications three times every day for the
                            rest of his life and that unless he changed his diet, he likely had only a few years to live
                            — in poor health.
                          </p>
                          <p>And then his doctor gave Grandpa Irv a book and told him to read it.</p>
                        </Col>
                      </Row>
                      <p>
                        The book was already familiar to him because it was written by his son (my dad), John Robbins.
                        But he hadn’t read it.
                      </p>
                      <p>
                        You see, there were some hard feelings in the family. Decades earlier, my grandpa had been
                        grooming my dad, John, to one day join in the family business.
                      </p>
                      <p>
                        But when he was in his early 20’s, my dad wound up walking away from Baskin-Robbins and the
                        wealth it represented because it didn't align with his values of health and compassion.
                      </p>
                      <p>
                        My dad left that legacy to follow his own "rocky road" and become a best-selling food and health
                        author. The media had fun with the story, calling him the “rebel without a cone.”
                      </p>
                      <p>
                        Millions of people were inspired by his work — including, as fate would have it, Grandpa Irv’s
                        doctor, who was now recommending my dad's best-selling book, Diet for a New America, to his
                        patient.
                      </p>
                      <Row className="d-flex justify-content-center">
                        <Col xs="12" lg="7" xl="8">
                          <p>And amazingly enough, Grandpa Irv read the book and made some big changes.</p>
                          <p>
                            He added lots of vegetables and fruits; he went plant-powered, and he even gave up ice
                            cream!
                          </p>
                          <h4 className="my-4">
                            My Grandpa Irv ended up getting off all his medications and adding almost 20 more healthy
                            years to his life.
                          </h4>
                        </Col>
                        <Col xs="12" sm="8" lg="5" xl="4" className="img-ocean-note-suits-row text-center">
                          <img
                            className="img-ocean-note img-ocean-note-suits img-fluid img-rotate-right"
                            src={require('static/irvine-john-ocean.jpg')}
                          />
                        </Col>
                      </Row>

                      <Row className=" d-flex justify-content-center align-items-center">
                        <Col xs="12" lg="8" className="order-lg-2">
                          <p>
                            The great news is that this is the kind of transformation I know is possible for anyone,
                            including you and your loved ones.
                          </p>
                          <h4 className="my-4">That's how POWERFUL food is.</h4>
                          <p>
                            My dad and I have spent decades living our passion to empower millions of people with this
                            life-saving knowledge.
                          </p>
                        </Col>
                        <Col xs="12" sm="8" lg="4" className="img-ocean-note-flexing-row text-center order-lg-1">
                          <img
                            className="img-ocean-note img-ocean-note-flexing img-fluid rounded-circle"
                            src={require('static/speaker/john-ocean-square.jpg')}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Section>

            <Section id="ppt-testimonials-2" color="light-gray" angle="both">
              <Container>
                <Row>
                  <Col>
                    <TestimonialBubble id="kari-z" bgColor="white" />
                    <hr className="my-5" />
                    <TestimonialBubble id={variant === 'ad' ? 'cheryl-s-ad' : 'cheryl-s'} bgColor="white" />
                    <hr className="my-5" />
                    <TestimonialBubble id={variant === 'ad' ? 'eric-c-ad' : 'eric-c'} bgColor="white" />
                  </Col>
                </Row>
              </Container>
            </Section>

            <SectionImage
              id="ppt-confusion"
              color="white"
              imgPosition="right"
              imgUrl={require('static/backgrounds/market-square.jpg')}
              imgUrlMobile={require('static/backgrounds/market.jpg')}
              title={
                <h2 className="section-only-heading">
                  To really THRIVE, you need a balanced mix of the right whole foods.
                </h2>
              }
              titleClass="text-center mb-5"
            >
              <ul className="list-question-green">
                <li>
                  Would you like to know exactly what the data tells us about the optimal dietary pattern that can
                  benefit billions of people?
                </li>
                <li>
                  Are you worried that you might make the wrong choice on a critical issue like gluten, grains, soy, or
                  protein?
                </li>
                <li>How can you eat out and trust what’s on your plate?</li>
                <li>Is there really arsenic in rice?</li>
                <li>Does BPA-free plastic really leach estrogenic compounds into your food?</li>
                <li>Is frozen as good as fresh? What about canned?</li>
                <li>
                  How can you tell what’s right for YOU? What questions should you be asking? What signs should you be
                  looking for? What foods should you be suspicious of?
                </li>
              </ul>
              <h5 className="mb-0">The confusion ends here!</h5>
            </SectionImage>

            <SectionImage
              id="ppt-empower"
              color="light-gray"
              imgPosition="left"
              imgUrl={require('static/backgrounds/kitchen-square.jpg')}
              imgUrlMobile={require('static/backgrounds/kitchen.jpg')}
              title={<h2 className="section-only-heading">Are you ready to take control of your health?</h2>}
              titleClass="text-center mb-5"
            >
              <h4 className="section-heading">This course will empower you to…</h4>
              <ul className="list-check-green">
                <li>Get the scientifically proven essential nutrients your body needs</li>
                <li>Make living a healthy life easy</li>
                <li>Eat deliciously satisfying and deeply nourishing food without breaking the bank</li>
                <li>Prepare meals without having to toil over the stove for hours on end</li>
                <li>Get your loved ones to eat healthfully (without conflict!)</li>
                <li>Utilize simple hacks to make wholesome food taste amazing</li>
                <li>
                  Enjoy a plant-powered diet that’s been proven to not just help you{' '}
                  {variant === 'ad' ? '' : 'lose weight and '}be fit – but also to{' '}
                  {variant === 'ad' ? '' : 'drastically improve your odds to '}prevent cancer, heart disease, diabetes,
                  and many other ailments – deliciously!
                </li>
                <li>
                  Get your hardest questions answered. John, Ocean, Chef Cynthia, and our team of seasoned food
                  revolution leaders are here for YOU. We’ll delight in answering your questions about healthy food!
                </li>
              </ul>
            </SectionImage>

            <Section id="ppt-imagine" color="gradient-indigo-purple-right" innerClass="text-white">
              <Container>
                <Row className="text-center">
                  <Col>
                    {!salesFullPrice ? (
                      <>
                        <h1 className="section-heading">
                          Right Now Just <del>$497</del> $297
                        </h1>
                        <CheckoutButton sku="ppt" price="297" slug="ppt-special-wlc-30daytrial" />
                      </>
                    ) : (
                      <>
                        <h1 className="section-heading">Right Now $497</h1>
                        <CheckoutButton sku="ppt" price="497" slug="ppt-wlc-30daytrial" />
                      </>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <h2>Imagine what it will be like to be:</h2>
                    <div>
                      <ImgBullet img={require('static/salivating.jpg')}>
                        <h4 className="section-heading">Salivating...</h4>
                        <p>
                          on your way to work as you think about the delicious lunch you put together the night before.
                        </p>
                      </ImgBullet>

                      <ImgBullet img={require('static/excited.jpg')}>
                        <h4 className="section-heading">Excited...</h4>
                        <p>
                          to invite friends or family over for a meal, even if they don’t eat as healthfully as you do.
                          They’ll be asking for your recipes!
                        </p>
                      </ImgBullet>

                      <ImgBullet img={require('static/with-plans.jpg')}>
                        <h4 className="section-heading">With Plans...</h4>
                        <p>
                          You’ll spend less time driving, waiting in checkout lines, scrambling to throw something
                          together, going hungry, or snacking on processed foods.
                        </p>
                      </ImgBullet>

                      <ImgBullet img={require('static/with-time.jpg')}>
                        <h4 className="section-heading">With Time...</h4>
                        <p>
                          You’ll have more time for the things you love, including time with friends and family, sleep,
                          exercise, gardening, and preparing meals you enjoy.
                        </p>
                      </ImgBullet>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Section>
          </section>

          <section id="hosts">
            <Section id="ppt-hosts" color="white">
              <Container>
                <Row>
                  <Col>
                    <h1 className="section-only-heading text-center text-lg-left">Meet Your Hosts</h1>
                  </Col>
                </Row>
              </Container>
            </Section>

            <SectionImage
              id="ppt-host-john"
              color="black"
              imgPosition="right"
              innerClass="text-white"
              imgUrl={require('static/speaker/john-robbins-veggies-square.jpg')}
              imgUrlMobile={require('static/speaker/john-robbins-veggies-square.jpg')}
            >
              <h3 className="section-heading">John Robbins</h3>
              <p>
                John Robbins could have inherited the Baskin-Robbins empire. But he walked away from the money and the
                power. Why? He simply didn’t want to devote his life to selling ice cream after realizing it makes
                people unhealthy. So, he decided to make a change.
              </p>
              <p>
                Over the last several decades, his books about healthy eating and healthy living (including bestsellers,{' '}
                <em>Diet for a New America</em> and <em>The Food Revolution</em>) have sold millions of copies and been
                translated into more than 31 languages. In the 5 years after the publication of his first best-selling
                book, feedlot beef consumption in the United States dropped by over 20% (a representative for the
                National Cattlemen’s Beef Association, speaking on NPR, blamed John Robbins). Hundreds of thousands of
                people consider his work responsible for transforming their health.
              </p>
              <p>He’ll provide seasoned wisdom and steady guidance you can trust.</p>
            </SectionImage>

            <SectionImage
              id="ppt-host-ocean"
              color="black"
              imgPosition="left"
              innerClass="text-white"
              imgUrl={require('static/speaker/ocean-robbins-veggies-square.jpg')}
              imgUrlMobile={require('static/speaker/ocean-robbins-veggies-square.jpg')}
            >
              <h3 className="section-heading">Ocean Robbins</h3>
              <p>
                The food revolution has been in Ocean’s blood since before he was born. He grew up in a log cabin built
                by his parents, eating food they grew on the land together. At the age of 10, he started a natural foods
                bakery and ran his first marathon. By 15 he was speaking at the United Nations and opening for the Jerry
                Garcia Band. Over the last several decades he has spoken in person to more than 250,000 people in 65+
                nations and hosted online events for millions. He’s the author of the new book,{' '}
                <em>31-Day Food Revolution: Heal Your Body, Feel Great, & Transform Your World,</em> and has served as
                an adjunct professor at Chapman University.
              </p>
              <p>
                Ocean wanted to make the food revolution reach everyone and to make it easy and accessible for people
                from all walks of life. So in 2012, he founded Food Revolution Network with his dad and has since guided
                millions of people to a healthier way of eating and living.
              </p>
              <p>
                No matter where you’re starting from, his warmth and approachable demeanor will welcome and carry you
                through the course journey every step of the way.
              </p>
            </SectionImage>

            <SectionImage
              id="ppt-host-cynthia"
              color="black"
              imgPosition="right"
              innerClass="text-white"
              imgUrl={require('static/speaker/cynthia-louise-square.jpg')}
              imgUrlMobile={require('static/speaker/cynthia-louise-square.jpg')}
            >
              <h3 className="section-heading">Chef Cynthia Louise</h3>
              <p>
                Chef Cynthia’s genius is in taking traditional favorite foods and transforming them into simple healthy
                dishes full of flavor. She brings a global perspective to cuisine and a passionate love of healthy food
                that is irresistible!
              </p>
              <p>
                Chef Cynthia has created 3 best-selling cookbooks and has been a savior to many households around the
                globe. She brings so much of her personality to w​​​​hat she does that it’s no surprise her down to
                earth nature has made her e-books, Bali retreats, and online cooking classes a huge success. She grew up
                in Papua New Guinea, studied at the top health retreats in Australia, and is now a Qualified Wholefood
                Chef based in beautiful Bali, Indonesia, focusing on vegetarian and dairy-free food and drinks.
              </p>
              <p>
                Her playful approach to cooking makes it simple and delightful. She’ll help you develop genuine joy in
                preparing healthy meals that are delicious and easy to make.
              </p>
            </SectionImage>
          </section>

          <section id="learn">
            <Section id="ppt-modules" color="white">
              <Container>
                <Row>
                  <Col>
                    <h2 className="section-heading">How We Will Make You a Seasoned Plant-Powered Pro:</h2>
                  </Col>
                </Row>
                <Row className="mb-5">
                  <Col>
                    <ModuleAccordion />
                  </Col>
                </Row>
                <Row className="text-center mt-5">
                  <Col>
                    <h3 className="section-heading">It’s more fun to go on the journey with peers!</h3>
                  </Col>
                </Row>
                <Row className="d-flex justify-content-center">
                  <Col xs="12" sm="8" lg="6">
                    <img className="img-fluid" src="https://cdn.foodrevolution.org/ppt/ppt-forum-desktop.png" />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-center text-center">
                  <Col lg="10">
                    <p>
                      Get access to our private and moderated online <br className="d-none d-sm-block d-xl-none" />
                      community forum, <br className="d-none d-xl-block" />
                      where you can connect with peers, share struggles and successes, and{' '}
                      <br className="d-none d-xl-block" />
                      receive expert advice. <br className="d-none d-sm-block d-xl-none" />
                      (And by the way, this forum is NOT on Facebook.)
                    </p>
                    <p>
                      When you register for Plant-Powered & Thriving, <br className="d-none d-sm-block d-md-none" />
                      you’ll become part <br className="d-none d-xl-block" />
                      of an inspired, vibrant community <br className="d-none d-sm-block d-md-none" />
                      of individuals just like you who are <br className="d-none d-xl-block" />
                      excited to be <br className="d-none d-sm-block d-md-none" />
                      part of the food revolution.
                    </p>
                    <p>
                      <strong>This is more than a course — it’s a community!</strong>
                    </p>
                  </Col>
                </Row>
              </Container>
            </Section>

            <Section id="ppt-testimonials-3" color="light-gray">
              <Container>
                <Row>
                  <Col>
                    <TestimonialBubble id="liz" bgColor="white" />
                    <hr className="my-5" />
                    <TestimonialBubble id="linda" bgColor="white" />
                    <hr className="my-5" />
                    <TestimonialBubble id="susan" bgColor="white" />
                  </Col>
                </Row>
              </Container>
            </Section>

            <Section id="ppt-join-cta-1" color="gradient-indigo-purple-right">
              <Container>
                <Row>
                  <Col>
                    <h2 className="section-heading text-center text-white text-shadow">
                      Join Now to Take Charge of Your Health
                    </h2>
                    <CtaBox />
                  </Col>
                </Row>
              </Container>
            </Section>
          </section>

          <section id="bonuses">
            <Section id="ppt-testimonials-4" color="light-gray">
              <Container>
                <Row>
                  <Col>
                    <TestimonialBubble id="linda-b" bgColor="white" />
                    <hr className="my-5" />
                    <TestimonialBubble id="denise-a" bgColor="white" />
                  </Col>
                </Row>
              </Container>
            </Section>
            <Section id="ppt-bonuses" color="white">
              <Container>
                <Row>
                  <Col>
                    <h2 className="section-heading">And There’s Even More! Enroll Now For These Powerful Bonuses</h2>
                    <p>
                      When you join Plant-Powered & Thriving, you’ll gain access to a{' '}
                      <br className="d-none d-lg-block" />
                      powerful collection of free bonuses from our friends and partners!
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <BonusList />
                  </Col>
                </Row>
              </Container>
            </Section>

            <Section id="ppt-join-cta-2" color="gradient-indigo-purple-right">
              <Container>
                <Row className="d-flex justify-content-center">
                  <Col sm="10" md="8" lg="12">
                    <h2 className="section-heading text-center text-white text-shadow">Take Charge of Your Health</h2>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <CtaBox />
                  </Col>
                </Row>
              </Container>
            </Section>

            <Section id="ppt-testimonials-5" color="light-gray">
              <Container>
                <Row>
                  <Col>
                    <TestimonialBubble id={variant === 'ad' ? 'ingrid-s-ad' : 'ingrid-s'} bgColor="white" />
                  </Col>
                </Row>
              </Container>
            </Section>

            <Section id="ppt-junk-food" color="white">
              <Container>
                <Row>
                  <Col>
                    <h2 className="section-heading">
                      Junk food – even “healthy” junk food – is addictive. And addictions cost, big time.
                    </h2>
                    <p>
                      Food addictions lead to spending money on unhealthy foods, of course. But they also lead to higher
                      medical costs, to lower energy and reduced productivity at work, and to a less vibrant and joyful
                      life. There is a direct link between the food you eat and your level of physical, emotional, and
                      mental wellness.
                    </p>
                    <p>
                      <strong>
                        When your body actually gets the nourishment <br className="d-none d-sm-block d-lg-none" />
                        it needs, it’s satisfied.
                      </strong>
                    </p>
                    <h2>The truth is, your health is priceless.</h2>
                    <p>
                      John, Ocean, and Cynthia have spent decades researching healthy eating and helping millions of
                      people put it into practice. This course distills their insights and helps put you on the path of
                      vibrant health.
                    </p>
                    <p>What’s that worth?</p>
                    <p>
                      What’s it worth to have your health, and to have habits in place that make it easy for you to save
                      time and money doing the right thing for you and your loved ones?
                    </p>
                    <p>The reality is that the information in this course could be sold for thousands of dollars.</p>
                    <p>
                      <strong>
                        But, this is too important to keep it expensive <br className="d-none d-sm-block d-md-none" />
                        and exclusive.
                      </strong>
                    </p>
                    <p>
                      We’re on a mission to change the way the world eats and to help millions of people to implement
                      and thrive with a plant-powered lifestyle. So we priced it as low as we could while still
                      (hopefully!) covering our costs, and are offering the course for the special price of only $497.
                    </p>
                    <p>
                      But right now, because we want as many people as possible to be able to benefit from this course,
                      we’re testing an even lower price for a very limited time. So you get to save an additional $200,
                      while we experiment and find out if this model is viable long-term.
                    </p>
                  </Col>
                </Row>
              </Container>
            </Section>
          </section>

          <section id="enroll">
            <Section id="ppt-join-hosts" color="green" innerClass="background-green text-white text-shadow">
              <Container>
                <Row>
                  <Col>
                    <h2 className="section-only-heading">
                      {
                        {
                          1: (
                            <>
                              Join Now with John, Ocean, Cynthia, and this Powerful Community and Put Healthy Eating
                              into ACTION
                            </>
                          ),
                          2: (
                            <>
                              Join Now with John, Ocean, Cynthia, and this Powerful Community and Take Your Healthy
                              Eating to the Next Level
                            </>
                          ),
                          3: (
                            <>
                              Join Now with John, Ocean, Cynthia, and this Powerful Community and Take Your Healthy
                              Eating to the Next Level
                            </>
                          )
                        }[bucket]
                      }
                    </h2>
                  </Col>
                </Row>
              </Container>
            </Section>

            <Section id="ppt-included" color="white">
              <Container>
                <Row>
                  <Col>
                    <h2 className="section-heading">Here's Everything You Get When You Enroll:</h2>
                    <ul className="list-hr">
                      <li>
                        6 modules (plus The Basics), each with video lessons from John Robbins, Ocean Robbins, and Chef
                        Cynthia
                      </li>
                      <li>
                        All lessons available in HD video. MP3s and transcripts of the lessons with John and Ocean also
                        available for easy download.
                      </li>
                      <li>Access to an Exclusive Forum (that’s NOT on Facebook)</li>
                      <li>6 Fabulous & Easy-To-Prepare Recipes Every Week &mdash; Soy-Free, GMO-Free, Gluten-Free</li>
                      <li>
                        The basic recipe collection is 100% plant-based and non-GMO with gluten-free and soy-free
                        options that are super easy to implement.
                      </li>
                      <li>7 delightful recipe preparation videos with chef Cynthia (see exactly how she does it!)</li>
                      <li>12 Potent Special Reports </li>
                      <li>
                        Guest Faculty Interviews with Dr. Dean Ornish, Kathy Freston, Dr. Joel Fuhrman, Brenda Davis,
                        Dr. Caldwell Esselstyn, and Michael Bernard Beckwith
                      </li>
                      <li>
                        Q&A with John Robbins, Ocean Robbins, & Chef Cynthia – where we answer the TOP questions from
                        our community (pre-recorded).
                      </li>
                    </ul>
                    <h4>And you also get these health-boosting bonuses:</h4>
                    <ul className="list-hr">
                      <li>
                        <strong className="text-purple">BONUS:</strong>
                        <br />
                        <em>G-BOMBS e-Book</em>
                        <br />
                        From Dr. Joel Fuhrman
                      </li>
                      <li>
                        <strong className="text-purple">BONUS:</strong>
                        <br />
                        <em>The Ornish Lifestyle Medicine Program</em>
                        <br />
                        From Dr. Dean Ornish
                      </li>
                      <li>
                        <strong className="text-purple">BONUS:</strong>
                        <br />
                        <em>Cancer Healing Special Report</em>
                        <br />
                        From Caryn Hartglass
                      </li>
                      <li>
                        <strong className="text-purple">BONUS:</strong>
                        <br />
                        <em>Dessert Plantz eCookbook</em>
                        <br />
                        From Plant-Based Katie Mae
                      </li>
                      <li>
                        <strong className="text-purple">BONUS:</strong>
                        <br />
                        <em>Eat Your Way Out of Pain Home Study Program</em>
                        <br />
                        From Dr. Ritamarie Loscalzo
                      </li>
                      <li>
                        <strong className="text-purple">BONUS:</strong>
                        <br />
                        <em>The Dairy-Freedom Cookbook</em>
                        <br />
                        From Allison Rivers Samson
                      </li>
                    </ul>
                    <h4>Unlimited Access. Enjoy it all as many times as you want.</h4>
                  </Col>
                </Row>
              </Container>
            </Section>

            <Section id="ppt-join-cta-3" color="gradient-indigo-purple-right">
              <Container>
                <Row>
                  <Col>
                    <h2 className="section-heading text-center text-white text-shadow">
                      Make food the foundation of YOUR health — the easy way!
                    </h2>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <CtaBox noProtected />
                  </Col>
                </Row>
              </Container>
            </Section>

            <Section id="ppt-guarantee" color="light-gray">
              <Container>
                <Row>
                  <Col>
                    <Guarantee />
                  </Col>
                </Row>
              </Container>
            </Section>

            <Section id="ppt-testimonials-6" color="white">
              <Container>
                <Row>
                  <Col>
                    <TestimonialBubble id={variant === 'ad' ? 'margaret-p-ad' : 'margaret-p'} />
                  </Col>
                </Row>
              </Container>
            </Section>
          </section>

          <Section id="faqs" color="light-gray">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-heading">Frequently Asked Questions</h2>
                  <FaqList />
                </Col>
              </Row>
            </Container>
          </Section>

          <Section id="ppt-testimonials-7" color="white">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-heading text-center mb-5">More Responses from Course Participants</h2>
                  <TestimonialBubble id="rhonda-h" />
                  <hr className="my-5" />
                  <TestimonialBubble id="linda-d" />
                  <hr className="my-5" />
                  <TestimonialBubble id="wendy-p" />
                  <hr className="my-5" />
                  <TestimonialBubble id="marium-a" />
                  <hr className="my-5" />
                  <TestimonialBubble id="chuck-g" />
                  <hr className="my-5" />
                  <TestimonialBubble id="cecile-n" />
                  <hr className="my-5" />
                  <TestimonialBubble id={variant === 'ad' ? 'donna-n-ad' : 'donna-n'} />
                  <hr className="my-5" />
                  <TestimonialBubble id="terri-c" />
                  <hr className="my-5" />
                  <TestimonialBubble id="shayne-t" />
                  <hr className="my-5" />
                  <TestimonialBubble id="shelley" />
                  <hr className="my-5" />
                  <TestimonialBubble id="gretchen" />
                  <hr className="my-5" />
                  <TestimonialBubble id="pat" />
                </Col>
              </Row>
            </Container>
          </Section>

          <Section id="ppt-join-cta-4" color="gradient-indigo-purple-right" className="section-angle-last" angle="none">
            <Container>
              <Row>
                <Col>
                  <CtaBox />
                </Col>
              </Row>
            </Container>
          </Section>
        </div>
      </div>

      {noExitIntent ? null : <>{!salesFullPrice ? <ModalExitSales /> : null}</>}
      <div className="footer-content mt-auto">
        <Footer />
        <ShareButtons floating />
      </div>
    </div>
  );
}
